import { GetServerSideProps, NextPage } from 'next';
import { ParsedUrlQuery } from 'querystring';
import { getCSRFToken, getProjectByAlias } from '~/src/services/projects/projectApi';
import { getCityInfo } from '~/src/services/api/api-content/geography/get-city-info';
import LandingPage from '~/src/containers/LandingPage';
import { ILandingPage, prepareServerProps } from '~/src/services/projects/prepareServerProps';

interface IPathProps extends ParsedUrlQuery {
    domain: string;
    alias: string;
}

const LandingProductionPage: NextPage<ILandingPage> = (props): JSX.Element => {
    return <LandingPage {...props} />;
};

export const getServerSideProps: GetServerSideProps<ILandingPage, IPathProps> = async (context) => {
    const { params } = context;

    const { domain, alias } = params;

    const [result, city] = await Promise.all([
        getProjectByAlias(`${alias}`),
        getCityInfo({ domain }),
    ]);

    if (!result.isSuccess) {
        console.error(`Project ${alias} not found`);

        return {
            notFound: true,
        };
    }

    if (result.isSuccess) {
        const { cities } = result.payload;

        if (cities) {
            const isProjectAvailableInCity = cities.split(',').includes(city.name);

            if (!isProjectAvailableInCity) {
                return {
                    redirect: {
                        destination: `https://${domain}.dom.ru/`,
                        permanent: false,
                    },
                };
            }
        }

        const { payload } = result;
        const CSRFToken = await getCSRFToken();
        const token = CSRFToken.isSuccess ? CSRFToken.payload.token : '';

        return {
            props: prepareServerProps(alias, payload, city, token),
        };
    }
};

export default LandingProductionPage;
